var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{staticStyle:{"width":"500px"},attrs:{"title":"百度地图","bordered":false,"body-style":{padding: 0}}},[_c('div',{ref:"mapContainer",staticClass:"map-container"})])
}
var staticRenderFns = []

export { render, staticRenderFns }